module.exports = __webpack_public_path__ + "img/screenshot_yunzhen.a6508d88.png";